import DropdownFilter from "./DropdownFilter";

const VariationsFilter = ({ parameters, onFilterChange }) => {
  return (
    <div style={{ display: "flex", gap: "var(--gap-sm)" }}>
      {parameters?.map((parameter) => (
        <DropdownFilter
          key={parameter.id}
          parameter={parameter}
          onFilterChange={onFilterChange}
        />
      ))}
    </div>
  );
};

export default VariationsFilter;
